//Site Blue JS

// window.$ = window.jQuery = require('jquery');
global.jQuery = require("jquery");
global.$ = require("jquery");
// global.$ = global.jQuery = require("jquery");
require('../js/lib/pushy.js');
require('../js/lib/slick.js');
// require('../js/truwp-scripts.js'); For now this file is empty, so commenting this
require('../../../truwp-child/_src/dark-blue/js/site-scripts.js');